<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':modalDisplay}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        @if (respDesc == '') {
          <h4 class="modal-title margin_center">Oops! Something went wrong.</h4>
        }
        @if (respDesc != '') {
          <h4 class="modal-title margin_center text-align-center"><span
          class="semi_bold_mont">ERROR: </span>{{respDesc}}</h4>
        }
      </div>
      <div class="modal-body">
        <div class="row justify-content-center">

          <div class="gap20"></div>

          <div class="col-4">
            @if (respDesc == '') {
              <button type="submit" class="proceed-btn" (click)="navigateToDashboard()"
              >Yes</button>
            }
            @if (respDesc != '') {
              <button type="submit" class="proceed-btn" (click)="navigateToDashboard()"
              >OK</button>
            }
          </div>
          <div class="gap20"></div>
        </div>
      </div>
    </div>
  </div>
  <div class="overlay"></div>
</div>